<template>
  <div
    v-if="active"
    class="loading-overlay"
  >
    <BaseSpinner />
  </div>
</template>

<script setup>
import BaseSpinner from '@/components/BaseSpinner.vue';

defineProps({
  active: Boolean,
});
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;

  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  color: var(--white);
  font-size: 24px;
}
</style>
